import { useSelector } from 'react-redux';
import { selectCurrentRole } from 'selectors';
import { get, upperFirst } from 'lodash';
import * as is from '../utils/roles';

const useRoles = () => {
  const role = useSelector(selectCurrentRole);

  const isAllowedTo = rawPrivilege => {
    const privilege = rawPrivilege.replace('allowedTo', '');
    const formattedPrivilege = `allowedTo` + upperFirst(privilege);
    const allowedRoles = get(is, formattedPrivilege, []);
    return allowedRoles.indexOf(role) > -1;
  };

  return {
    role,
    isAllowedTo,
  };
};

export default useRoles;
